<img (click)="selectUser(user.id)" class="profile pointer" 
            *ngIf="presence$ | async as presence" 
            [ngClass]="{
                'imgBorderGreen':  presence.status  === 'online',
                'imgBordergray': presence.status  === 'away' || presence.status  === 'offline'
            }"
            [src]="user.profilePicture"> &nbsp;